export default __webpack_public_path__ + "static/investment-solutions-d4a758bebb2facfa12e856b5d98b7882.png";